module.exports = {
	"title": "CSS Scroll snap points",
	"description": "CSS technique that allows customizable scrolling experiences like pagination of carousels by setting defined snap points.",
	"spec": "http://www.w3.org/TR/css-snappoints-1/",
	"status": "wd",
	"links": [
		{
			"url": "http://generatedcontent.org/post/66817675443/setting-native-like-scrolling-offsets-in-css-with",
			"title": "Blog post"
		},
		{
			"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Scroll_Snap_Points",
			"title": "MDN Documentation for CSS Scroll snap points"
		},
		{
			"url": "https://github.com/ckrack/scrollsnap-polyfill",
			"title": "Polyfill"
		}
	],
	"bugs": [],
	"categories": [
		"CSS"
	],
	"stats": {
		"ie": {
			"6": "n",
			"7": "n",
			"8": "n",
			"9": "n",
			"10": "a x #1",
			"11": "a x #2",
			"5.5": "n"
		},
		"edge": {
			"12": "a x #2",
			"13": "a x #2",
			"14": "a x #2"
		},
		"firefox": {
			"2": "n",
			"3": "n",
			"4": "n",
			"5": "n",
			"6": "n",
			"7": "n",
			"8": "n",
			"9": "n",
			"10": "n",
			"11": "n",
			"12": "n",
			"13": "n",
			"14": "n",
			"15": "n",
			"16": "n",
			"17": "n",
			"18": "n",
			"19": "n",
			"20": "n",
			"21": "n",
			"22": "n",
			"23": "n",
			"24": "n",
			"25": "n",
			"26": "n",
			"27": "n",
			"28": "n",
			"29": "n",
			"30": "n",
			"31": "n",
			"32": "n",
			"33": "n",
			"34": "n",
			"35": "n",
			"36": "n",
			"37": "n",
			"38": "n",
			"39": "y",
			"40": "y",
			"41": "y",
			"42": "y",
			"43": "y",
			"44": "y",
			"45": "y",
			"46": "y",
			"47": "y",
			"48": "y",
			"49": "y",
			"50": "y",
			"51": "y",
			"52": "y",
			"53": "y",
			"3.5": "n",
			"3.6": "n"
		},
		"chrome": {
			"4": "n",
			"5": "n",
			"6": "n",
			"7": "n",
			"8": "n",
			"9": "n",
			"10": "n",
			"11": "n",
			"12": "n",
			"13": "n",
			"14": "n",
			"15": "n",
			"16": "n",
			"17": "n",
			"18": "n",
			"19": "n",
			"20": "n",
			"21": "n",
			"22": "n",
			"23": "n",
			"24": "n",
			"25": "n",
			"26": "n",
			"27": "n",
			"28": "n",
			"29": "n",
			"30": "n",
			"31": "n",
			"32": "n",
			"33": "n",
			"34": "n",
			"35": "n",
			"36": "n",
			"37": "n",
			"38": "n",
			"39": "n",
			"40": "n",
			"41": "n",
			"42": "n",
			"43": "n",
			"44": "n",
			"45": "n",
			"46": "n",
			"47": "n",
			"48": "n",
			"49": "n",
			"50": "n",
			"51": "n",
			"52": "n",
			"53": "n",
			"54": "n",
			"55": "n",
			"56": "n",
			"57": "n"
		},
		"safari": {
			"4": "n",
			"5": "n",
			"6": "n",
			"7": "n",
			"8": "n",
			"9": "a x #4",
			"10": "a x #4",
			"3.1": "n",
			"3.2": "n",
			"5.1": "n",
			"6.1": "n",
			"7.1": "n",
			"9.1": "a x #4",
			"TP": "a x #4"
		},
		"opera": {
			"9": "n",
			"11": "n",
			"12": "n",
			"15": "n",
			"16": "n",
			"17": "n",
			"18": "n",
			"19": "n",
			"20": "n",
			"21": "n",
			"22": "n",
			"23": "n",
			"24": "n",
			"25": "n",
			"26": "n",
			"27": "n",
			"28": "n",
			"29": "n",
			"30": "n",
			"31": "n",
			"32": "n",
			"33": "n",
			"34": "n",
			"35": "n",
			"36": "n",
			"37": "n",
			"38": "n",
			"39": "n",
			"40": "n",
			"41": "n",
			"42": "n",
			"43": "n",
			"9.5-9.6": "n",
			"10.0-10.1": "n",
			"10.5": "n",
			"10.6": "n",
			"11.1": "n",
			"11.5": "n",
			"11.6": "n",
			"12.1": "n"
		},
		"ios_saf": {
			"8": "n",
			"10": "y x",
			"3.2": "n",
			"4.0-4.1": "n",
			"4.2-4.3": "n",
			"5.0-5.1": "n",
			"6.0-6.1": "n",
			"7.0-7.1": "n",
			"8.1-8.4": "n",
			"9.0-9.2": "y x",
			"9.3": "y x"
		},
		"op_mini": {
			"all": "n"
		},
		"android": {
			"3": "n",
			"4": "n",
			"53": "n",
			"2.1": "n",
			"2.2": "n",
			"2.3": "n",
			"4.1": "n",
			"4.2-4.3": "n",
			"4.4": "n",
			"4.4.3-4.4.4": "n"
		},
		"bb": {
			"7": "n",
			"10": "n"
		},
		"op_mob": {
			"10": "n",
			"11": "n",
			"12": "n",
			"37": "n",
			"11.1": "n",
			"11.5": "n",
			"12.1": "n"
		},
		"and_chr": {
			"53": "n"
		},
		"and_ff": {
			"49": "n"
		},
		"ie_mob": {
			"10": "n",
			"11": "n"
		},
		"and_uc": {
			"11": "n"
		},
		"samsung": {
			"4": "n"
		}
	},
	"notes": "Works in the iOS WKWebView, but not UIWebView.",
	"notes_by_num": {
		"1": "Partial support in IE10 refers to support limited to touch screens.",
		"2": "Partial support in IE11 [documented here](https://dl.dropboxusercontent.com/u/444684/openwebref/CSS/scroll-snap-points/support.html)",
		"3": "Can be enabled in Firefox using the `layout.css.scroll-snap.enabled` flag in `about:config`",
		"4": "Partial support in Safari refers to not supporting the `none` keyword in `scroll-snap-points-x`, `scroll-snap-points-y` and `scroll-snap-coordinate`, and length keywords (`top`, `right`, etc.) in `scroll-snap-destination` and `scroll-snap-coordinate`."
	},
	"usage_perc_y": 14.93,
	"usage_perc_a": 7.65,
	"ucprefix": false,
	"parent": "",
	"keywords": "scroll-snap-points-x,scroll-snap-points-y,scroll-snap-type,scroll-snap-destination,scroll-snap-coordinate",
	"ie_id": "cssscrollingsnappoints",
	"chrome_id": "",
	"firefox_id": "",
	"webkit_id": "specification-css-scroll-snap-points-module-level-1",
	"shown": true
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/features-json/css-snappoints.json
 ** module id = 432
 ** module chunks = 0
 **/